<form [formGroup]="form" #formDirective="ngForm" (ngSubmit)="onSubmit(formDirective)">
  <ion-card>
    <ion-card-header>
      <div class="flex-container margin-bottom">
        <div class="left-column">
          <ion-title class="ion-no-padding">
            <ion-label>{{title}}</ion-label>
          </ion-title>
        </div>
        <div class="right-column">
          <ion-button class="app-btn footer-btn" shape="round" fill="outline" size="medium" (click)="onCancel(formDirective)">
            {{'Cancel' | translate }}
          </ion-button>
          <ion-button class="app-btn footer-btn" type="submit" shape="round" fill="outline" size="medium">
            {{'Submit' | translate }}
          </ion-button>
        </div>
      </div>
    </ion-card-header>
    <ion-card-content class="card-container scrollVertical">
      <div class="form-scroll">
        <formly-form appFormlyCaretAtEnd [form]="form" [fields]="fields" [model]="model"></formly-form>
      </div>
    </ion-card-content>
  </ion-card>
</form>